var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.33377, 279.158236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 78.265625 0 C 134.027344 0 167.289062 -33.996094 167.289062 -91.226562 C 167.289062 -148.210938 135.003906 -184.410156 77.042969 -184.410156 L 18.34375 -184.410156 L 18.34375 0 Z M 62.121094 -41.089844 L 62.121094 -144.542969 L 74.351562 -144.542969 C 104.433594 -144.542969 120.574219 -126.199219 120.574219 -91.226562 C 120.574219 -59.921875 103.210938 -41.089844 75.328125 -41.089844 Z M 62.121094 -41.089844 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.650326, 279.158236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 132.804688 0 L 132.804688 -43.289062 L 62.121094 -43.289062 L 62.121094 -184.410156 L 18.34375 -184.410156 L 18.34375 0 Z M 132.804688 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.568707, 279.158236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 66.035156 0 L 66.035156 -184.410156 L 20.789062 -184.410156 L 20.789062 0 Z M 66.035156 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.392645, 279.158236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 123.753906 -62.121094 C 119.839844 -45.734375 107.125 -38.886719 92.449219 -38.886719 C 71.171875 -38.886719 56.742188 -58.941406 56.742188 -92.9375 C 56.742188 -122.289062 71.171875 -145.765625 92.203125 -145.765625 C 108.589844 -145.765625 119.597656 -137.695312 124 -123.019531 L 168.269531 -123.019531 C 163.375 -163.867188 133.78125 -189.546875 92.449219 -189.546875 C 39.132812 -189.546875 10.027344 -144.054688 10.027344 -93.183594 C 10.027344 -34.972656 41.089844 5.136719 91.714844 5.136719 C 132.558594 5.136719 161.910156 -12.71875 168.023438 -62.121094 Z M 123.753906 -62.121094 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(590.709224, 279.158236)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 96.605469 0 L 96.605469 -143.808594 L 142.832031 -143.808594 L 142.832031 -184.410156 L 6.113281 -184.410156 L 6.113281 -143.808594 L 51.851562 -143.808594 L 51.851562 0 Z M 96.605469 0 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d1c91312c4bea2fba353abbd43549a83.svg";
export { ForwardRef as ReactComponent };